module.exports = __webpack_public_path__ + "e04e29eb635b02fe4da33e3d2d39f52c.png";